import { RainbowText } from '~/components/ui/RainbowText';

export const lead = (
  <>
    <RainbowText>Awesome LED List</RainbowText> is a community-maintained reference for the
    addressable LED ecosystem. Our goal is to help makers, installers, and enthusiasts find the
    right products for their projects.
  </>
);

## History

Cameron Tacklind started this project as a [Google Sheets document](https://docs.google.com/spreadsheets/d/10pHG7_VIVltyqJK1Y0T5g3Iq6YJV2MnhMp3UcAVB-GA) to organize information about LED controllers, pixels, and related products.
With the help of communities like [LEDs ARE AWESOME](https://www.facebook.com/groups/LEDSAREAWESOME) on Facebook and [r/led](https://www.reddit.com/r/led/) and [r/WLED](https://www.reddit.com/r/WLED/) on Reddit, contributors added more data and tabs over time.

As usage grew, Google Sheets's limitations and drawbacks became apparent.
Cameron had long envisioned a dedicated website, but never found the time.
In 2026, Claude built the initial version, and Cameron refined it into the first public version.

## Downloads

- [Database (CSV)](/database.csv.zip) - All categories as CSV files
- [Database (YAML)](/database.yaml.zip) - Raw YAML source files
- [Source Code](https://github.com/cinderblock/awesomeledlist/archive/refs/heads/master.zip) - Full repository
- [GitHub Repository](https://github.com/cinderblock/awesomeledlist)

## Contributing

All data is stored in human-readable YAML files on GitHub.
If you'd like to add or update information, you can submit a pull request to the repository.

## Disclaimer

Information is provided "as-is" with no guarantee of accuracy.
Product specifications may change, and we recommend verifying details with manufacturers before making purchasing decisions.

## License

The database of this site is licensed under the ODbL 1.0 (Open Database License).

The website code is licensed under the AGPL 3.0 (Affero General Public License).
